export class GiftMallConfigRecord {
  constructor (record) {
    this.organizations = record.organizations
    this.recipient = record.recipient
  }
}



// WEBPACK FOOTER //
// ./src/js/records/giftmallconfig.record.js